<template lang="html">
  <div>
    <div class="mng-model-scene">
      <div>
        <div id="drag">
          <div>
            <div>
              <div id="buttonL">
                <el-button @click=onWall($event)>画墙</el-button>
                <el-button @click=onDoor($event)>画门</el-button>
              </div>
              <div id="buttonR">
                <el-button @click="preCanvas($event)">上一步</el-button>
                <el-button @click="getPoint($event)">保存</el-button>
              </div>
              <div id="buttonDR">
                <el-button >旋转1</el-button>
                <el-button >旋转2</el-button>
              </div>
              <div id="buttonDL">
                <el-button >放大</el-button>
                <el-button >缩小</el-button>
              </div>
            </div>
            <div id="canvasBG2">
              <div ref="demo1"></div>
            </div>
            <div id="canvasBG">
              <canvas id="canvas2"
                      width="400"
                      height="400">
              </canvas>
            </div>
            <div id="wrap">
              <canvas id="canvas"
                      width="400"
                      height="400"
                      @mouseup="canvasUp($event)"
                      @mousemove="canvasMove($event)"
                      @touchend="canvasUp($event)"
                      @touchmove="canvasMove($event)"
                      @click="drawWallPoint($event)">
              </canvas>
            </div>
          </div>
        </div>
        <div id="inset" @click="onClickInset"></div>
        <div 
          id="vr-container"
          :style="{zIndex: showVr ? 101 : 0, visibility: showVr ? 'visible' : 'hidden'}"
        >
          <vr-scene
            ref="vrScene"
            :scene-id="$route.params.modelId"
            @ready="handleVrReady" 
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  Scene, Color, PerspectiveCamera, WebGLRenderer, AxisHelper, SpotLight,
  OrthographicCamera, CubeGeometry, Mesh, MeshBasicMaterial, Vector3,
  Vector2,BoxGeometry, Raycaster, Group
} from 'three';

import VrScene from '@/components/owllySence/VrScene';

import { OrbitControls } from '../../../controls/OrbitControls';
import { GLTFLoader } from '../../../loaders/GLTFLoader';


export default {

  filters: {
    firstImage(imageList) {
      if (!imageList || !imageList.length) return '';
      return imageList[0];
    }
  },
  components: {
    VrScene
  },
  directives: {
    // drag(el) {
    //   el.onmousedown = function (e) {
    //     //  获取鼠标点击处分别与div左边和上边的距离：鼠标位置-div位置;
    //     const divx = e.clientX - document.getElementById('drag').offsetLeft;
    //     const divy = e.clientY - document.getElementById('drag').offsetTop;
    //     //  包含在onmousedown里，表示点击后才移动，为防止鼠标移出div，使用document.onmousemove
    //     //  console.log(e.clientX, document.getElementById('drag').offsetLeft);

    //     //  console.log(divx, divy);
    //     if (divy >= 100) return;
    //     document.onmousemove = function (me) {
    //       //  获取移动后div的位置：鼠标位置-divx/divy
    //       const l = me.clientX - divx;
    //       const t = me.clientY - divy;
    //       document.getElementById('drag').style.left = `${l}px`;
    //       document.getElementById('drag').style.top = `${t}px`;
    //     };
    //     document.onmouseup = function () {
    //       document.onmousemove = null;
    //       document.onmouseup = null;
    //     };
    //   };
    // }
  },
  data() {
    return {
      context: {},
      scene: {},
      labelDialogVisible: false,
      loading: true,
      sceneData: [],
      CANVAS_WIDTH: 800,
      CANVAS_HEIGHT: 800,
      CAM_DISTANCE: 300,
      ORT_WIDTH: 400,
      ORT_HEIGHT: 400,
      //  存储当前表面状态数组-上一步
      preDrawAry: [],
      //  存储当前表面状态数组-下一步
      nextDrawAry: [],
      //  中间数组
      middleAry: [],
      //  配置参数
      wallStyle: {
        lineWidth: 2,
        lineColor: '#ffffff',
        shadowBlur: 8,
        strokeStyle: '#ffffff'
      },
      doorStyle: {
        lineWidth: 1,
        lineColor: '#ffffff',
        shadowBlur: 5,
        strokeStyle: '#ffffff'
      },
      DRAW_WIDTH: 400,
      DRAW_HEIGHT: 600,
      startPoint: {},
      endPotin: {},
      isDoor: false,
      pointUVList: [],
      showVr: false
    };
  },
  computed: {
    wrappedDescription() {
      return this.label.description ? this.label.description.split('\n') : [];
    }
  },
  mounted() {
    this.inset = document.querySelector('#inset');
    this.onInitialized();
    const canvas = document.querySelector('#canvas');
    this.context = canvas.getContext('2d');

    const canvas2 = document.querySelector('#canvas2');
    this.context2 = canvas2.getContext('2d');
    this.initDraw();
  },
  methods: {
    onInitialized() {
      this.loadSceneData();
      this.initMesh();
    },
    onDoor() {
      this.isDoor = true;
    },
    onWall() {
      this.isDoor = false;
    },
    async loadSceneData() {
      this.loading = true;
      const { data: { data: sceneData } } = await this.$http.post(
        '/v1/list-panoramas?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
        { store_id: this.$route.params.modelId }
      );
      //  console.log(sceneData);
      this.scenePoint = sceneData.panorama_list.map((pano) => {
        const p = { coordinate: {} };
        p.coordinate.positionX = pano.coordinate.position_x;
        p.coordinate.positionY = pano.coordinate.position_y;
        p.coordinate.positionZ = pano.coordinate.position_z;
        p.coordinate.directionX = pano.coordinate.direction_x;
        p.coordinate.directionY = pano.coordinate.direction_y;
        p.coordinate.directionZ = pano.coordinate.direction_z;
        p.coordinate.directionW = pano.coordinate.direction_w;
        p.coordinate.panoramaId = pano.coordinate.panorama_id;
        p.coordinate.id = pano.coordinate.id;
        p.panoramaImages = pano.panorama_images;
        p.panoramaImagesLow = pano.panorama_images_low;
        p.sequenceId = pano.seq_id;
        p.visiblePanoramaSequenceIds = pano.visible_panorama_seq_ids;
        p.visible = pano.visible;
        p.id = pano.id;
        return p;
      });
      //  console.log(this.sceneData);
      this.loadModel(sceneData.modelPath);
    },
    initDraw() {
      const preData = this.context.getImageData(0, 0, this.DRAW_WIDTH, this.DRAW_HEIGHT);
      //  空绘图表面进栈
      this.middleAry.push(preData);
    },
    initMesh() {
      this.scene = new Scene(); // 场景
      this.camera = new PerspectiveCamera(45,
        this.CANVAS_WIDTH / this.CANVAS_HEIGHT, 0.1, 1000); // 相机.视场，长宽比，近面，远面
      this.scene.background = new Color(196, 196, 196);
      this.camera.position.x = -15 * 0.8;
      this.camera.position.y = 40 * 0.8;
      this.camera.position.z = 30 * 0.8;
      this.camera.lookAt(this.scene.position);

      this.renderer = new WebGLRenderer({ antialias: true });// 渲染器
      this.renderer.setSize(this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      //  this.renderer.shadowMapEnabled = true // 开启阴影
      const axes = new AxisHelper(20);// 坐标轴
      //  this.scene2 = new Scene();
      //  this.scene2.background= new Color(0xEEEEEE);
      //  camera2
      this.camera2 = new OrthographicCamera(-5, 28, 10, -28, 0.1, 1000);
      this.camera2.position.y = 5;

      //  this.camera2.up=new Vector3(1,0,0);
      this.camera2.lookAt(this.scene.position);
      //  console.log(this.camera2.up);

      //  this.camera2.rotation.z = this.camera2.rotation.z - Math.PI / 6;

      this.scene.add(this.camera2);

      this.renderer2 = new WebGLRenderer({ antialias: true });//  渲染器
      this.renderer2.setSize(400, 400);


      const spotLight = new SpotLight(0xffffff);
      spotLight.position.set(-40, 200, -10);
      spotLight.castShadow = true;

      this.scene.add(axes);// 场景添加坐标轴

      this.scene.add(spotLight);

      this.mcontrols = new OrbitControls(this.camera, this.renderer.domElement);
      //  console.log("method----",this.inset);
      this.inset.append(this.renderer.domElement);
      this.$refs.demo1.append(this.renderer2.domElement);

      this.renderThisFrame = true;
      this.renderScene();

      //  事件
      this.mcontrols.addEventListener('_render', () => {
        this.renderThisFrame = true;
      });
    },
    renderScene() {
      if (this.renderThisFrame) {
        this.renderer.render(this.scene, this.camera);
        this.renderer2.render(this.scene, this.camera2);
      }
      this.renderThisFrame = false;
      requestAnimationFrame(this.renderScene);
    },
    loadModel(modelPath) {
      const gltfLoader = new GLTFLoader();
      gltfLoader.load(modelPath, (gltf) => {
        // console.log(this.dumpObject(gltf.scene).join('\n'));
        const object = gltf.scene;
        object.rotateX(-Math.PI / 2);
        object.updateWorldMatrix();
        this.model = object;
        this.scene.add(object);
        this.draw3DPotint();
        this.renderThisFrame = true;
        this.loading = false;
      });
    },
    draw3DPotint() {
      this.pointGroup = new Group()
      // console.log('=====================================',this.scenePoint);
      this.scenePoint.forEach((element) => {
        // console.log('=====================================',BoxGeometry);
        const cube = new Mesh(
          // new CubeGeometry(1, 1, 1, 1, 1, 1),
          new BoxGeometry(1,1,1),
          new MeshBasicMaterial({ color: 0xff0000, wireframe: true }) // , wireframe: true
        );
        let orgposition = new Vector3(element.coordinate.positionX,
          element.coordinate.positionY, element.coordinate.positionZ);
        orgposition = orgposition.clone().applyAxisAngle(new Vector3(1, 0, 0), -Math.PI / 2);
        cube.position.x = orgposition.x;
        cube.position.y = orgposition.y;
        cube.position.z = orgposition.z;
        this.pointGroup.add(cube);
        element.cube = cube;
      });
      this.scene.add(this.pointGroup);
    },
    // 添加点击事件
    onClickInset(event) { 
      if (!this.pointGroup) {return}
      // 计算相交点是不是全景点
      const raycaster = new Raycaster()
      const pointer = new Vector2(
        (event.offsetX / event.currentTarget.clientWidth) * 2 - 1,
        - (event.offsetY / event.currentTarget.clientHeight) * 2 + 1
      )
      raycaster.setFromCamera(pointer, this.camera);
      const [intersect] = raycaster.intersectObjects(this.pointGroup.children);
      if (intersect) {
        const element = this.scenePoint.find(item => item.cube === intersect.object)
        if (element) {
          this.onClick3DPoint(element)
        }
      }
    },
    // 点击全景点
    onClick3DPoint(element) {
      this.setElementActive(element)
      this.$refs.vrScene.stage.panoCtl.moveToPanorama(element.id);
    },
    handleVrReady() { 
      this.$refs.vrScene.stage.addEventListener('click_panorama', ({ pid }) => {
        const element = this.scenePoint.find(item => item.id === pid)
        this.setElementActive(element)
      })
    },
    setElementActive(element) {
      this.scenePoint.forEach(item => {
        item.cube.material.color = new Color(0xff0000)
      })
      element.cube.material.color = new Color(0x00ff00)
      this.renderer.render(this.scene, this.camera);
      this.showVr = true;
    },
    async saveImage() {
      //  console.log('save image and point date!');
      const canvas = document.querySelector('#canvas');
      const image = canvas.toDataURL('image/png');
      try {
        const { data } = await this.$http.post(
          '/admin/modify-store-floor-plan',
          {
            store_id: this.$route.params.modelId,
            floor_plan: image.replace(/data:image.*?,/gi, '')
          }
        );
        //  console.log(data);
        if (data.error_no === 200) {
          this.$message.basic({
            message: '添加成功'
          });
          this.closeDialog();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async savePointUV() {
      //  console.log('save image and point UV!');

      try {
        const { data } = await this.$http.post(
          '/admin/modify-store-uv-list',
          {
            store_id: this.$route.params.modelId,
            uv_list: this.pointUVList
          }
        );
        //  console.log(data);
        if (data.error_no === 200) {
          this.$message.basic({
            message: '添加UV成功'
          });
          this.closeDialog();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    preCanvas() {
      if (this.preDrawAry.length) {
        //  console.log(this.preDrawAry);
        const popData = this.preDrawAry.pop();
        const midData = this.middleAry[this.preDrawAry.length + 1];
        this.nextDrawAry.push(midData);
        this.context.putImageData(popData, 0, 0);
      } else {
        this.context.clearRect(0, 0, this.DRAW_WIDTH, this.DRAW_HEIGHT);
        this.preDrawAry = [];
        this.nextDrawAry = [];
        this.middleAry = [this.middleAry[0]];
      }
    },
    getPoint() {
      return;
      // this.context.clearRect(0, 0, this.DRAW_WIDTH, this.DRAW_HEIGHT);
      this.scenePoint.forEach((element) => {
        //  console.log(element);
        const vector2D = element.cube.position.clone().project(this.camera2);
        vector2D.x = this.ORT_WIDTH * vector2D.x / 2 + this.ORT_WIDTH / 2;
        vector2D.y = -this.ORT_HEIGHT * vector2D.y / 2 + this.ORT_HEIGHT / 2;
        const point2D = {
          id: element.id,
          position: vector2D
        };
        const arcPosX = point2D.position.x - document.getElementById('drag').offsetLeft + 20; // 20,20 是右面布局的起始坐标
        const arcPosY = point2D.position.y - document.getElementById('drag').offsetTop - 20 + 40;
        this.draw2DPoint(arcPosX, arcPosY, 1);
        this.renderThisFrame = true;
        this.pointUVList.push([arcPosX / 400, arcPosY / 400]);
      });
      //  console.log(this.pointUVList);
      this.savePointUV();
      this.saveImage();
    },
    draw2DPoint(posX, posY, radius) {
      this.context.beginPath();
      //  this.context.fillText(id, posX, posY);
      this.context.arc(posX,
        posY,
        radius, 0, 2 * Math.PI, true);
      //  this.context.moveTo(posX - document.getElementById('drag').offsetLeft,
      //  posY - document.getElementById('drag').offsetTop);
      //  this.context.lineTo(posX - document.getElementById('drag').offsetLeft + 2,
      //  posY - document.getElementById('drag').offsetTop + 2);
      //  当前绘图表面状态
      this.context.closePath();
      this.context.stroke();
      this.context.fill();
    },
    drawMousePoint(posX, posY, radius) {
      //  console.log(posX, posY, radius);
      this.context2.clearRect(0, 0, this.context2.canvas.width, this.context2.canvas.height);
      this.context2.beginPath();
      this.context2.arc(posX,
        posY,
        radius, 0, 2 * Math.PI, true);
      this.context2.closePath();
      this.context2.stroke();
      this.context2.fill();
    },
    //  设置绘画配置
    setCanvasStyle() {
      if (this.isDoor) {
        this.context.lineWidth = this.doorStyle.lineWidth;
        this.context.shadowBlur = this.doorStyle.shadowBlur;
        this.context.shadowColor = this.doorStyle.lineColor;
        this.context.strokeStyle = this.doorStyle.strokeStyle;
        this.context.fillStyle = this.doorStyle.strokeStyle;
      } else {
        this.context.lineWidth = this.wallStyle.lineWidth;
        this.context.shadowBlur = this.wallStyle.shadowBlur;
        this.context.shadowColor = this.wallStyle.lineColor;
        this.context.strokeStyle = this.wallStyle.strokeStyle;
        this.context.fillStyle = this.wallStyle.strokeStyle;
      }
    },
    drawWallPoint(e) {
      const canvasX = e.clientX - document.getElementById('drag').offsetLeft - e.target.parentNode.offsetLeft - 130;
      const canvasY = e.clientY - document.getElementById('drag').offsetTop - e.target.parentNode.offsetTop - 60;
      this.setCanvasStyle();
      if (this.isDoor) {
        this.draw2DPoint(canvasX, canvasY, 1);
      } else {
        this.draw2DPoint(canvasX, canvasY, 2);
      }
      this.startPoint = new Vector2(canvasX, canvasY);
      const preData = this.context.getImageData(0, 0, this.DRAW_WIDTH, this.DRAW_HEIGHT);
      this.preDrawAry.push(preData);
      this.canvasMoveUse = true;
    },
    // mousedown
    canvasDown(e) {
      this.canvasMoveUse = true;
      const canvasX = e.clientX - document.getElementById('drag').offsetLeft - e.target.parentNode.offsetLeft - 130;
      const canvasY = e.clientY - document.getElementById('drag').offsetTop - e.target.parentNode.offsetTop - 60;
      this.startPoint = new Vector2(canvasX, canvasY);
      //  this.setCanvasStyle();
      // 清除子路径
      // 当前绘图表面状态
      const preData = this.context.getImageData(0, 0, this.DRAW_WIDTH, this.DRAW_HEIGHT);
      this.preDrawAry.push(preData);
    },
    canvasMove(e) {
      this.context2.lineWidth = this.doorStyle.lineWidth;
      this.context2.shadowBlur = this.doorStyle.shadowBlur;
      this.context2.shadowColor = this.doorStyle.lineColor;
      this.context2.strokeStyle = this.doorStyle.strokeStyle;
      this.context2.fillStyle = this.doorStyle.strokeStyle;

      const canvasX = e.clientX - document.getElementById('drag').offsetLeft - e.target.parentNode.offsetLeft - 130;//  130 60 拖动框到00的位置
      const canvasY = e.clientY - document.getElementById('drag').offsetTop - e.target.parentNode.offsetTop - 60;
      this.drawMousePoint(canvasX, canvasY, 5);
      if (this.canvasMoveUse) {
        //  console.log(this.preDrawAry);
        this.context.putImageData(this.preDrawAry[this.preDrawAry.length - 1], 0, 0);
        this.context.beginPath();
        this.setCanvasStyle();
        this.context.moveTo(this.startPoint.x, this.startPoint.y);
        this.context.lineTo(canvasX, canvasY);
        this.context.stroke();
        this.context.closePath();
        //  console.log(canvasX, canvasY);
      }
    },
    // mouseup
    canvasUp(e) {
      if (e.button === 2) {
        //  console.log('right click');
        if (this.canvasMoveUse) {
          this.context.putImageData(this.preDrawAry[this.preDrawAry.length - 1], 0, 0);
          this.canvasMoveUse = false;
        }
      }
    }
  },
  // 操作
  controlCanvas(action) {
    switch (action) {
      case 'prev':
        if (this.preDrawAry.length) {
          const popData = this.preDrawAry.pop();
          const midData = this.middleAry[this.preDrawAry.length + 1];
          this.nextDrawAry.push(midData);
          this.context.putImageData(popData, 0, 0);
        }
        break;
      case 'next':
        if (this.nextDrawAry.length) {
          const popData = this.nextDrawAry.pop();
          const midData = this.middleAry[this.middleAry.length - this.nextDrawAry.length - 2];
          this.preDrawAry.push(midData);
          this.context.putImageData(popData, 0, 0);
        }
        break;
      case 'clear':
        this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
        this.preDrawAry = [];
        this.nextDrawAry = [];
        this.middleAry = [this.middleAry[0]];
        break;
      default:
        break;
    }
  }
};
</script>

<style lang="scss" scoped>
.editor-panel-markers {
  display: flex;

  &__marker {
    height: 28px;
    width: 28px;
    border-radius: 2px;
    background-color: #d8d8d8;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    cursor: pointer;

    &--add {
      background-color: transparent;
      border: 1px solid #999;
      height: 26px;
      width: 26px;
    }

    img {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }

    &--selected {
      border: 2px solid #a9a9a9;
      height: 24px;
      width: 24px;
    }
  }

  &__uploader {
    visibility: hidden;
    position: absolute;
    height: 0;
    width: 0;
    display: inline-block;
  }
}

.editor-panel-list {
  height: 350px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;

  &__title {
    display: grid;
    background-color: #e5e5e5;
    grid-template-columns: 50% 50%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;
    color: #666;
    user-select: none;
  }

  &__items {
    overflow-y: scroll;
    flex: 1;
  }

  &__item {
    display: grid;
    background-color: #fff;
    grid-template-columns: 50% 50%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;
    border-bottom: 1px solid #e5e5e5;

    span {
      color: #666;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  &__actions .ai-button {
    margin: 0 6px;
  }
}

.label-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }

  &__content {
    display: flex;
    padding: 20px 16px;
  }

  &__footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .ai-button {
      width: 59px;
      height: 26px;
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

.form {
  display: inline-block;
}

.form-item {
  margin-bottom: 20px;
  width: 100%;
  display: flex;

  &:last-child {
    margin-bottom: 0;
  }

  &__label {
    display: inline-flex;
    width: 70px;
    color: #6c6c6c;
    font-size: 14px;
    height: 28px;
    align-items: center;
    flex-direction: row-reverse;
    user-select: none;
  }

  &__content {
    display: inline-block;
    margin-left: 12px;

    .ai-input-wrapper {
      width: 327px;
      height: 28px;
    }

    textarea {
      width: 327px;
      height: 80px;
      font-size: 12px;
    }
  }
}

.item-select {
  width: 295px;
  height: 144px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .2);
  border-radius: 4px;
  padding: 16px;
  overflow-y: scroll;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;

  &__item {
    width: 58px;
    height: 58px;
  }
}

.preview {
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 10px;
  padding: 20px 0;
  border: 1px solid #ffffff;
  background-color: #ffffff;
}

.item-info {
  min-width: 272px;
  min-height: 288px;
  text-align: right;
  color: #fff;
  filter: drop-shadow(0 2px 2px #000);
  user-select: none;
  pointer-events: none;

  &__title {
    font-size: 26px;
    line-height: 40px;
    border-bottom: 2px solid #fff;
  }

  &__text {
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;
  }
}

#canvas {
  position: absolute;
  left: 1px;
  top: 1px;
  z-index: 80;
}

#canvas2 {
  position: absolute;
  left: 1px;
  top: 1px;
  z-index: 100;
}

#wrap {
  width: 400px;
  height: 800px;
  position: absolute;
  top: 40px;
  z-index: 80;
}

#demo1 {
  width: 400px;
  height: 400px;
  position: absolute;
  left: 132px;
  top: 133px;
  z-index: 10;
}

#canvasBG {
  width: 400px;
  height: 400px;
  background: black;
  opacity: .2;
  position: absolute;
  top: 40px;
  z-index: 1;
}

#canvasBG2 {
  width: 400px;
  height: 400px;
  position: absolute;
  top: 40px;
  border: 1px solid #000;
  z-index: 1;
}

#buttonR {
  position: absolute;
  top: 5px;
  right: 5px;
}

#buttonDL {
  position: absolute;
  bottom:  5px;
  right: 5px;
}

#buttonDR {
  position: absolute;
  bottom:  5px;
}


#buttonL {
  position: absolute;
  top: 5px;
}


#drag {
  width: 400px;
  height: 480px;
  position: absolute;
  top: 20px;
  left: 20px;
  border-radius: 2px;
}

#inset {
  width: 800px;
  height: 800px;
  background-color: rgb(255, 255, 255); /* or transparent; */
  border: 1px solid black; /* or none; */
  position: absolute;
  left: 460px;
  top: 20px;
  z-index: 100;
}

#vr-container {
  height: 800px;
  position: absolute;
  left: 860px;
  right: 0;
  top: 20px;
  z-index: 0;
  visibility: hidden;
}
</style>
